// @ts-check
import React, { useState } from 'react';
import styled from 'styled-components';

// Core
import { Dropdown } from 'core/components/Dropdown';

const Container = styled.div`
  .dropdown-container {
    margin: 20px 0;
  }

  .export-button-disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

// Export type options
const exportOptions = [
  { value: 'csv', label: 'CSV file' },
  { value: 'salesforce', label: 'Enterprise Salesforce Marketing Cloud FTP' },
];

/**
 * @param {{
 *  onCancel: () => void,
 *  onExportTypeSelection: (exportType: string) => void,
 * }} props
 */
const ExportTypeModal = ({ onCancel, onExportTypeSelection }) => {
  const [selectedExportType, setSelectedExportType] = useState(null);

  // Handle export type selection change
  const handleExportTypeChange = (selected) => {
    setSelectedExportType(selected);
  };
  // Handle export button click
  const handleExport = () => {
    if (selectedExportType) {
      onExportTypeSelection(selectedExportType.value);
    }
  };

  // Check if an export type is selected
  const isExportDisabled = !selectedExportType;
  return (
    <Container>
      <div className="d-flex justify-content-between mb-1 mt-1">
        <div>
          <h4>Export Format</h4>
          <p>Select the file type or destination for your export.</p>
        </div>
      </div>

      <div className="form-group" id="search-dropdown-field">
        <label htmlFor="export-type-dropdown">Select export option</label>
        <Dropdown
          placeholder="Select export type"
          options={exportOptions}
          value={selectedExportType}
          isSearchable={false}
          portalMenu
          onChange={handleExportTypeChange}
        />
      </div>

      <div className="d-flex justify-content-between gap-2 mt-4">
        <button
          type="button"
          className="btn btn-md btn-gray"
          aria-describedby="cancel-export-list"
          data-ga-event="link"
          data-ga-action="click"
          data-ga-name="onclick"
          data-ga-type="cta"
          data-ga-region="main content"
          data-ga-section="Export Type Modal"
          data-ga-component=""
          data-ga-text="Cancel"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className={`btn btn-md btn-maroon ${
            isExportDisabled ? 'export-button-disabled' : ''
          }`}
          type="button"
          aria-describedby="do-export-list"
          disabled={isExportDisabled}
          data-ga-event="link"
          data-ga-action="click"
          data-ga-name="onclick"
          data-ga-type="cta"
          data-ga-region="main content"
          data-ga-section="Export Type Modal"
          data-ga-component=""
          data-ga-text="Export"
          onClick={handleExport}
        >
          Export
        </button>
      </div>
    </Container>
  );
};

export { ExportTypeModal };
